<script>
  export let src = '';
  export let alt = 'Ảnh';
  export let onOpen;

  function openImage() {
    if (!src) return;
    onOpen?.(src);
  }
</script>

<button
  type="button"
  class="image-preview"
  disabled={!src}
  aria-label="Xem ảnh"
  on:click|stopPropagation={openImage}>
  <img src={src} {alt} loading="lazy" decoding="async" />
</button>

<style>
  .image-preview {
    appearance: none;
    display: block;
    max-width: min(19rem, 72vw);
    margin-top: 0.25rem;
    padding: 0;
    overflow: hidden;
    border: 0;
    border-radius: 0.42rem;
    background: transparent;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }

  .image-preview:disabled {
    cursor: not-allowed;
    opacity: 0.58;
  }

  img {
    display: block;
    max-width: 100%;
    max-height: 16rem;
    object-fit: contain;
    background: rgba(248, 250, 252, 0.72);
  }

  @media (max-width: 640px) {
    .image-preview {
      max-width: min(18rem, 76vw);
    }

    img {
      max-height: 14rem;
    }
  }
</style>
